import { VALUES } from "@/lib/site-data";
import { Target, Eye } from "lucide-react";

export default function About() {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="relative bg-[#F5F3EE] text-[#0A0A0A] py-24 md:py-32 overflow-hidden"
    >
      {/* Vertical accent line */}
      <div className="absolute left-0 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#385723]/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section heading */}
        <div className="grid grid-cols-12 gap-6 mb-20">
          <div className="col-span-12 md:col-span-4">
            <div className="flex items-center gap-3 mb-4">
              <span className="block w-8 h-px bg-[#385723]" />
              <span className="overline">01 · Nosotros</span>
            </div>
            <h2 className="heading-lg text-3xl sm:text-4xl lg:text-5xl text-[#0A0A0A]">
              Donde la ingeniería se vuelve obra.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-8 md:pl-8 md:border-l border-black/10">
            <p className="font-body text-base lg:text-lg text-[#3a3a3a] leading-relaxed mb-6">
              En <span className="text-[#0A0A0A] font-semibold">DISEÑO Y CONSTRUCCIÓN LUXE</span>{" "}
              materializamos proyectos donde la precisión de la ingeniería civil se encuentra con
              la excelencia arquitectónica. Nos especializamos en soluciones integrales{" "}
              <span className="text-[#006961] font-semibold">llave en mano</span>, abarcando desde
              la concepción del diseño hasta la ejecución de acabados de lujo y equipamiento
              especializado.
            </p>
            <p className="font-body text-base lg:text-lg text-[#3a3a3a] leading-relaxed">
              Nuestra capacidad operativa nos permite gestionar infraestructuras complejas con un
              rigor técnico que garantiza seguridad, durabilidad y una estética superior en cada
              metro cuadrado construido.
            </p>
          </div>
        </div>

        {/* Mission & Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-black/10 mb-16">
          <div className="bg-white p-10 md:p-12 group hover:bg-[#FAFAF7] transition-colors">
            <div className="flex items-start justify-between mb-6">
              <Target className="w-8 h-8 text-[#385723]" strokeWidth={1.5} />
              <span className="font-heading text-xs uppercase tracking-[0.3em] text-[#767171]">
                M·01
              </span>
            </div>
            <h3 className="heading-md text-2xl text-[#0A0A0A] mb-4">Misión</h3>
            <p className="font-body text-[#3a3a3a] leading-relaxed">
              Construir espacios innovadores y seguros mediante una ingeniería de precisión y un
              diseño funcional, superando las expectativas de nuestros clientes con integridad y
              eficiencia en cada proceso.
            </p>
          </div>

          <div className="bg-white p-10 md:p-12 group hover:bg-[#FAFAF7] transition-colors">
            <div className="flex items-start justify-between mb-6">
              <Eye className="w-8 h-8 text-[#006961]" strokeWidth={1.5} />
              <span className="font-heading text-xs uppercase tracking-[0.3em] text-[#767171]">
                V·01
              </span>
            </div>
            <h3 className="heading-md text-2xl text-[#0A0A0A] mb-4">Visión</h3>
            <p className="font-body text-[#3a3a3a] leading-relaxed">
              Consolidarnos como la constructora líder en el mercado nacional, reconocida por
              nuestra capacidad de transformar el entorno urbano y rural con proyectos sostenibles
              y de alta gama.
            </p>
          </div>
        </div>

        {/* Values */}
        <div>
          <div className="flex items-center gap-3 mb-8">
            <span className="block w-8 h-px bg-[#385723]" />
            <span className="overline">Valores que nos sostienen</span>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-black/10">
            {VALUES.map((v, i) => (
              <div
                key={i}
                className="bg-white p-6 md:p-8 flex flex-col items-start group hover:bg-[#FAFAF7] transition-all"
              >
                <div className="w-12 h-12 border border-[#385723] flex items-center justify-center mb-5 group-hover:bg-[#385723] transition-colors">
                  <v.Icon className="w-5 h-5 text-[#385723] group-hover:text-white transition-colors" strokeWidth={1.5} />
                </div>
                <span className="font-heading text-xs uppercase tracking-[0.2em] text-[#767171] mb-2">
                  0{i + 1}
                </span>
                <h4 className="heading-md text-base lg:text-lg text-[#0A0A0A]">
                  {v.title}
                </h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
